import { useEffect, useState } from "react";
import { Link, redirect } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useParams } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import logoBraspag from "assets/images/logo.svg";
import apiClient from "Api"
import Loading from "components/Loading";
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import LinkUI from '@mui/material/Link';
import MDLink from "components/MDLink";
import { BorderBottom } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';

function Basic() {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setpassword] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  let { tenantId } = useParams();
  let { appId } = useParams();

  if (tenantId) {
    if (tenantId.toLocaleLowerCase() == "ikigai") {
      tenantId = process.env.REACT_APP_IKIGAI_ID;
    } else if (tenantId.toLocaleLowerCase() == "cielo") {
      tenantId = process.env.REACT_APP_CIELO_ID;
    }
  }

  let isValid = (tenantId != undefined);

  function loginApi(e) {
    e.preventDefault();
    setIsLoading(true);
    let loginModel = {
      "email": email,
      "password": password
    };

    apiClient.post(`/account/login/${tenantId}`, loginModel).then(responseLogin => {
      setTimeout(function () {
        window.sessionStorage.removeItem("user");

        apiClient.defaults.headers.common["Authorization"] = `Bearer ${responseLogin.data.accessToken}`;

        apiClient.get(`/account/currentuser`).then(responseCurrentUser => {
          login({ data: responseCurrentUser.data, tokenData: responseLogin.data });
          setIsLoading(false);
        }).catch(e => {
          setIsLoading(false);
          enqueueSnackbar('Erro ao retornar dados do usuário!', { variant: "error" });
        });
      }, 500);
    }).catch(r => {
      setIsLoading(false);
      enqueueSnackbar('Usuário ou senha inválidos!', { variant: "error" });
    });
  }

  useEffect(() => {
    if (!isValid)
      enqueueSnackbar('Acesse pelo admin da Shopify!', { variant: "error" });
  }, [isValid]);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function sendResetPassword(email) {
    if (email !== undefined || email !== "") {
      setIsLoading(true);
      apiClient.post(`/account/forgotpassword/${tenantId}`, { email: email }).then(responseCurrentUser => {
        setIsLoading(false);
        enqueueSnackbar('E-mail de recuperação de senha enviado!', { variant: "success" });
      }).catch(e => {
        setIsLoading(false);
        enqueueSnackbar('Erro ao enviar e-mail de recuperação de senha!', { variant: "error" });
      });
    } else {
      enqueueSnackbar('E-mail inválido!', { variant: "error" });
    }
  }

  function redirectToCielo() {    
    window.open("https://www.cielo.com.br/gateway-de-pagamento", '_blank', 'noopener,noreferrer');
  }

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <>
      <BasicLayout>
        <Loading isLoading={isLoading}></Loading>
        <Grid container spacing={3} p={4}>
          <Grid item xs={12} md={12}>
            <MDBox component="img" src={logoBraspag} alt="Brand" width="8rem" fullwidth="true" />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card sx={{ minHeight: "21rem", maxWidth: 'md' }}>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="md"
                sx={{
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0
                }}
                coloredShadow="info"
                textAlign="start"
              >
                <MDTypography variant="h6" fontWeight="medium" color="white" pl={2.5} pr={2.5} p={2}>
                  Conecte-se
                </MDTypography>
              </MDBox>
              <MDBox p={4} pb={2}>
                <MDBox component="form" role="form" onSubmit={loginApi}
                  pb={2}
                  sx={{ borderBottom: "1px solid #7b809a2b" }}
                >
                  <MDBox mb={2}>
                    <MDTypography variant="body2" fontWeight="regular" color="dark" mb={1}>
                      E-mail *
                    </MDTypography>
                    <MDInput type="email" label="seu@email.com" fullWidth value={email} onChange={(event) => { setEmail(event.target.value); }} disabled={!isValid} required />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDTypography variant="body2" fontWeight="regular" color="dark" mb={1}>
                      Senha *
                    </MDTypography>
                    <MDInput type="password" fullWidth value={password} onChange={(event) => { setpassword(event.target.value); }} disabled={!isValid} required />
                  </MDBox>
                  <MDBox display="flex" alignItems="center">
                    <MDTypography variant="button" color="info" fontWeight="medium" textGradient onClick={handleClickOpen}>
                      Esqueceu a senha?
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={2} mb={1}>
                    <MDButton sx={{ borderRadius: "0.2rem" }} type="submit" variant="gradient" color="info" fullWidth disabled={!isValid}>
                      Entrar
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox >
              <MDBox p={4} pt={0}>
                <MDBox pb={1}>
                  <MDTypography variant="body2" color="dark" fontWeight="bold" sx={{ fontSize: "0.9rem" }}>
                    Primeiro acesso?
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDTypography variant="body2" color="dark" fontWeight="regular" sx={{ fontSize: "0.75rem" }}>
                    O e-mail de acesso foi criado e enviado para os dados de contato fornecidos na assinatura do contrato através do e-mail cielo@ikigai.dev.br. Verifique sua caixa de Spam.
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDLink sx={{ fontSize: "0.75rem", color: "#1A73E8" }} href="https://www.cielo.com.br/atendimento-ecomm/" target="_blank" rel="noopener noreferrer">
                    Problemas com o primeiro acesso?
                  </MDLink>
                </MDBox>
              </MDBox>
            </Card >
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card sx={{ minHeight: "21rem", maxWidth: 'md' }}>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="md"
                sx={{
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0
                }}
                coloredShadow="info"
                textAlign="start"
              >
                <MDTypography variant="h6" fontWeight="medium" color="white" pl={2.5} pr={2.5} p={2}>
                  Ainda não é Cliente Cielo?
                </MDTypography>
              </MDBox>
              <MDBox pl={4} pr={4} pt={4} pb={2}>
                <MDTypography variant="body2" color="dark" fontWeight="regular" sx={{ fontSize: "0.9rem" }}>
                  Gostaria de conhecer as soluções que temos para o seu negócio? Clique no link abaixo, preencha o formulário e em breve um especialista entrará em contato para apresentar as melhores soluções para seu perfil.
                </MDTypography>
              </MDBox>
              <MDBox pl={4} pr={4}>
                <MDButton sx={{ borderRadius: "0.2rem" }} variant="gradient" color="info" disabled={!isValid} onClick={redirectToCielo}>
                  Quero ser cliente Cielo
                </MDButton>
              </MDBox>
              <MDBox p={4} pt={2} pb={2}>
                <MDTypography variant="body2" color="text" fontWeight="regular" sx={{ fontSize: "0.75rem" }}>
                  Nossos especialistas estão prontos para ajudá-lo a expandir seu negócio
                  com as melhores soluções de pagamento disponíveis no mercado.
                </MDTypography>
              </MDBox>
            </Card>
          </Grid>
        </Grid>

        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth={true}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              sendResetPassword(formJson.email);
              handleClose();
            },
          }}
        >
          <DialogTitle>Esqueceu a senha?</DialogTitle>
          <DialogContent>
            <Grid container p={1}>
              <Grid item xs={12} mb={3}>
                <Alert severity="info" variant="outlined">
                  Você receberá um e-mail com o link para redefinição de senha.
                </Alert>
              </Grid>
              <Grid item xs={12} sm={12}>
                <MDInput autoFocus type="email" label="E-mail" name="email" fullWidth required />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MDButton onClick={handleClose}>Cancelar</MDButton>
            <MDButton type="submit" color="info" variant="contained">Enviar</MDButton>
          </DialogActions>
        </Dialog>

      </BasicLayout >
    </>
  );
}

export default Basic;
